var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 145,
    viewBox: "0 0 600 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3038_34628)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 145,
    fill: "#004060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.17 -1039.86L1161.16 752.754L17.9604 -224.362L1704.17 -1039.86Z",
    fill: "#00334D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.851 -107.28C709.669 -98.8079 706.768 -82.9039 694.59 -78.4452L-877.022 496.978C-889.366 501.498 -901.95 490.896 -899.59 477.963L-595.117 -1190.82C-592.758 -1203.75 -577.241 -1209.23 -567.288 -1200.64L699.851 -107.28Z",
    fill: "#002940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_34628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 145,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingHeader);
export default __webpack_public_path__ + "static/media/billing-header.1f084f5609a3fe3c531af5e07743901a.svg";
export { ForwardRef as ReactComponent };